var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 4.58366C9.65866 4.58366 9.37533 4.30033 9.37533 3.95866V2.29199C9.37533 1.95033 9.65866 1.66699 10.0003 1.66699C10.342 1.66699 10.6253 1.95033 10.6253 2.29199V3.95866C10.6253 4.30033 10.342 4.58366 10.0003 4.58366Z",
    fill: "#E3CDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0003 8.75033C14.6587 8.75033 14.3753 8.46699 14.3753 8.12533V2.29199C14.3753 1.95033 14.6587 1.66699 15.0003 1.66699C15.342 1.66699 15.6253 1.95033 15.6253 2.29199V8.12533C15.6253 8.46699 15.342 8.75033 15.0003 8.75033Z",
    fill: "#E3CDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.00033 8.75033C4.65866 8.75033 4.37533 8.46699 4.37533 8.12533V2.29199C4.37533 1.95033 4.65866 1.66699 5.00033 1.66699C5.34199 1.66699 5.62533 1.95033 5.62533 2.29199V8.12533C5.62533 8.46699 5.34199 8.75033 5.00033 8.75033Z",
    fill: "#E3CDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0836 7.38367L12.1836 9.58367C12.3336 9.88367 12.7336 10.1837 13.067 10.2337L15.0586 10.567C16.3336 10.7837 16.6336 11.7003 15.717 12.617L14.167 14.1753C13.9086 14.4337 13.7586 14.942 13.842 15.3087L14.2836 17.2337C14.6336 18.7503 13.8253 19.342 12.4836 18.5503L10.617 17.442C10.2753 17.242 9.7253 17.242 9.38364 17.442L7.50864 18.542C6.16697 19.3337 5.35864 18.742 5.70864 17.2253L6.1503 15.3003C6.23364 14.942 6.08364 14.4337 5.8253 14.167L4.28364 12.6253C3.36697 11.7087 3.66697 10.7837 4.94197 10.5753L6.93364 10.242C7.26697 10.1837 7.66697 9.892 7.81697 9.592L8.91697 7.392C9.50864 6.192 10.492 6.192 11.0836 7.38367Z",
    fill: "var(--secondaryText)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayRight);
export default __webpack_public_path__ + "static/media/play-right.0bd92bbf2305ecc28bf8a0c8f63ab2bf.svg";
export { ForwardRef as ReactComponent };